import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4eb0e62a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "page-title" }, "Authentification forte", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin":"10px 0"} }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Activez l'authentification forte (2FA) pour plus de sécurité et pour pouvoir vous connecter au Dashboard lors de vos déplacements.", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "p-text-secondary block mb-5" }, "Pour activer ou modifier l'authentification forte, scannez ce code barre avec votre application d'authentification (Google authenticator, Authy, Microsoft authenticator, Duo Mobile ou autres) sur votre téléphone. ", -1))
const _hoisted_6 = {
  key: 0,
  class: "flex align-items-center gap-3 mb-3"
}
const _hoisted_7 = ["src"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex justify-content-end gap-2" }, " Si vous avez perdu votre appareil contenant l'application d'authentification vous pouvez récupérer les codes en scannant ce QR Code à partir de votre nouveau téléphone. ", -1))

import {onMounted, ref} from 'vue';
import {useAuthStore} from '@/stores/auth/authStore';
import swal from "@/_helpers/swal";
import Button from "primevue/button";
import Dialog from 'primevue/dialog';


export default /*#__PURE__*/_defineComponent({
  __name: 'StrongAuthentication',
  setup(__props) {

const authStore = useAuthStore();
const qrCode = ref<string | null>(null);
const showDialog = ref<boolean>(false);

onMounted(async () => {
    await enableGoogleAuthenticatorSecret();
});

const enableGoogleAuthenticatorSecret = async () => {
    try {
        await authStore.enableGoogleAuthenticatorSecret();
    } catch (error) {
        console.error(`Erreur lors de l'activation du secret de google authenticator:`, error);
    }
};

const getQrCode = async () => {
    try {
        qrCode.value = await authStore.get2FaQrCode();
    } catch (error) {
        console.error('Erreur lors de la récupération du QR code:', error);
    }
};

const showQrCode = async () => {
    try {
        await getQrCode();

        showDialog.value = true;
    } catch (error) {
        const errorMsg = 'Erreur lors de la génération du QR code.';
        swal.error(errorMsg);
    }
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _createVNode(_unref(Button), {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (showQrCode())),
      size: "small",
      type: "button",
      severity: "warning",
      label: "Activer/Modifier 2FA",
      "aria-label": "Activer/Modifier 2FA",
      icon: "pi pi-lock"
    }),
    _createVNode(_unref(Dialog), {
      visible: showDialog.value,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((showDialog).value = $event)),
      maximizable: "",
      modal: "",
      header: "Activer/modifer 2FA",
      style: { width: '25rem' }
    }, {
      default: _withCtx(() => [
        _hoisted_5,
        (qrCode.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("img", {
                src: qrCode.value,
                alt: "QR Code",
                style: {"max-width":"100%","height":"auto"}
              }, null, 8, _hoisted_7)
            ]))
          : _createCommentVNode("", true),
        _hoisted_8
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}
}

})